const { CrudModel } = require('./crud');

export class PermissionModel extends CrudModel {
	constructor() {
		super('admin/permission', []);
	}

	myPermissions: any[] | null = null;

	async getMyPermissions() {
		if (!this.myPermissions) {
			this.myPermissions = await this.get('mine');
		}
		return this.myPermissions;
	}

	resetMyPermissions() {
		this.myPermissions = null;
	}
}

export default new PermissionModel();
